import React, { Component } from "react";
import axios from "axios";
import constant from "../../constant";
import PriceComp from "../../components/PriceComp";
import moment from "moment";
import "./style.scss";
import PopupComp from "../../components/PopupComp";
import { LoadingComp } from "../../components/LoadingComp";

export default class Accounts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 1,
      spent: 0,
      earned: 0,
      balance: 0,
      paywait: 0,
      transactions: null,
      bank_account: null,
      withdraw_amount: 1,
      bal_amount: 0,
      min_amount: 1,
      password: "",
      isCheckedPassword: false,
      error_pwd: "",
      bank: null,
      isOpenPopup: false,
      isLoading: true,
      errors: {}
    };
  }

  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    axios
      .get(`${constant.phpHost}action/dashboard.php`, {
        params: {
          todo: "get_user_account",
          en_id: this.props.user_id
        }
      })
      .then(res => {
        // console.log(res);
        this.setState({
          spent: res.data.spent,
          earned: res.data.earned,
          balance: res.data.balance,
          paywait: res.data.paywait,
          transactions: res.data.transactions,
          bank_account: res.data.bank_account,
          isLoading: false
        });
      });
  };

  handleChangeTab = tab => {
    this.setState(
      {
        tab
      },
      function() {
        if (tab === 3) {
          let bal_amount = document
            .getElementById("balance_amount")
            .innerHTML.split(" ")[1];

          let min_amount = document
            .getElementById("min_amount")
            .innerHTML.split(" ")[1];

          this.setState({
            bal_amount,
            min_amount,
            withdraw_amount: min_amount
          });
        }
      }
    );
  };

  handleChangeAmount = e => {
    this.setState({
      withdraw_amount: e.target.value
    });
  };

  handleBankEdit = bank => {
    this.setState({ bank, isOpenPopup: true });
  };

  handlePopup = () => {
    this.setState({ bank: null, isOpenPopup: !this.state.isOpenPopup });
  };

  handleBankDelete = id => {
    if (window.confirm("Are you sure you want to delete this?")) {
      axios
        .get(`${constant.phpHost}action/dashboard.php`, {
          params: {
            todo: "delete_bank",
            id: id
          }
        })
        .then(res => {
          let fadeTarget = document.getElementById("bank_" + id);
          let fadeEffect = setInterval(function() {
            if (!fadeTarget.style.opacity) {
              fadeTarget.style.opacity = 1;
            }
            if (fadeTarget.style.opacity > 0) {
              fadeTarget.style.opacity -= 0.1;
            } else {
              fadeTarget.style.display = "none";
              clearInterval(fadeEffect);
            }
          }, 100);
        });
    }
  };

  handleChange = (e, key) => {
    let state = this.state;
    state[key] = e.target.value;
    this.setState({ state });
  };

  // Check Password
  handleCheckPassword = e => {
    e.preventDefault();

    let formData = new FormData();
    formData.append("todo", "check_password");
    formData.append("en_id", this.props.user_id);
    formData.append("old_password", this.state.password);

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        let error_pwd = "";
        let isCheckedPassword = true;
        if (!response.data) {
          error_pwd = "Password did not match";
          isCheckedPassword = false;
        }

        this.setState({
          error_pwd,
          isCheckedPassword
        });
      });
  };

  handleSubmitWithdraw = e => {
    e.preventDefault();

    let formData = new FormData(e.target);
    formData.append("todo", "withdraw");
    formData.append("user_id", this.props.user_id);
    formData.delete("password");

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        this.setState(
          {
            tab: 4,
            withdraw_amount: this.state.min_amount,
            password: "",
            isCheckedPassword: false
          },
          this.initiate()
        );
      });
  };

  bank_validation = e => {
    let errors = {};
    let num_regx = /^[0-9]+$/;

    if (e.target.bank_holder.value === "") {
      errors["bank_holder"] = "Account holder name cannot be empty";
      e.target.bank_holder.focus();
      this.setState({
        errors
      });
      return;
    }

    if (e.target.bank_type.value === "") {
      errors["bank_type"] = "Bank name cannot be empty";
      e.target.bank_type.focus();
      this.setState({
        errors
      });
      return;
    }

    if (
      !e.target.bank_num.value.match(num_regx) ||
      e.target.bank_num.value === "" ||
      e.target.bank_num.value.length > 15
    ) {
      if (e.target.bank_num.value === "")
        errors["bank_num"] = "Account number cannot be empty";
      else errors["bank_num"] = "Check your account number is valid";

      e.target.bank_num.focus();
      this.setState({
        errors
      });
      return;
    }

    if (e.target.bank_ifsc.value === "") {
      errors["bank_ifsc"] = "IFSC code cannot be empty";
      e.target.bank_ifsc.focus();
      this.setState({
        errors
      });
      return;
    }

    return true;
  };

  handleSubmitBank = e => {
    e.preventDefault();

    if (this.bank_validation(e)) {
      let formData = new FormData(e.target);
      formData.append("todo", "bank_details");
      formData.append("user_id", this.props.user_id);
      if (this.state.bank) {
        formData.append("bank", "update");
      } else {
        formData.append("bank", "insert");
      }

      axios
        .post(`${constant.phpHost}action/dashboard.php`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.setState({ bank: null, isOpenPopup: false }, this.initiate());
        });
    }
  };

  render() {
    let {
      tab,
      spent,
      earned,
      balance,
      paywait,
      transactions,
      bank_account,
      withdraw_amount,
      bal_amount,
      min_amount,
      isCheckedPassword,
      error_pwd,
      bank,
      isOpenPopup,
      password,
      isLoading,
      errors
    } = this.state;

    function chk_errors(field) {
      return errors && errors[field] ? (
        <span
          style={{
            color: "red",
            display: "block",
            margin: "15px 0"
          }}
        >
          {errors[field]}
        </span>
      ) : null;
    }

    return !isLoading ? (
      <div>
        {isOpenPopup ? (
          <PopupComp isPopup={this.handlePopup}>
            <div className="form-group">
              <h2>{bank ? "Edit" : "Add"} Beneficiary Account</h2>
              <p>Please type valid account information.</p>
            </div>
            <form onSubmit={this.handleSubmitBank}>
              <div className="form-group">
                <label>Account Holder Name</label>
                <input
                  type="text"
                  name="bank_holder"
                  defaultValue={bank ? bank.bank_holder : ""}
                />
                {chk_errors("bank_holder")}
              </div>
              <div className="form-group">
                <label>Bank Name</label>
                <input
                  type="text"
                  name="bank_type"
                  defaultValue={bank ? bank.bank_type : ""}
                />
                {chk_errors("bank_type")}
              </div>
              <div className="form-group">
                <label>Account Number</label>
                <input
                  type="text"
                  name="bank_num"
                  defaultValue={bank ? bank.bank_num : ""}
                />
                {chk_errors("bank_num")}
              </div>
              <div className="form-group">
                <label>Bank IFSC</label>
                <input
                  type="text"
                  name="bank_ifsc"
                  defaultValue={bank ? bank.bank_ifsc : ""}
                />
                {chk_errors("bank_ifsc")}
              </div>
              <input
                type="hidden"
                name="id"
                defaultValue={bank ? bank.id : ""}
              />
              <div align="right" className="save_btn">
                <button>Save changes</button>
              </div>
            </form>
          </PopupComp>
        ) : null}

        <div className="edit-profile">
          <div className="block">
            <div className="left_" id="header_tab2">
              <div className="tab">
                <label
                  className={tab === 1 ? "active" : ""}
                  onClick={() => this.handleChangeTab(1)}
                >
                  <i className="fa fa-area-chart" />
                  Overview
                </label>
                <label
                  className={tab === 2 ? "active" : ""}
                  onClick={() => this.handleChangeTab(2)}
                >
                  <i className="fa fa-university" />
                  Bank Account
                </label>
                <label
                  className={tab === 3 ? "active" : ""}
                  onClick={() => this.handleChangeTab(3)}
                >
                  <i className="fa fa-money" />
                  Withdraw
                </label>
                <label
                  className={tab === 4 ? "active" : ""}
                  onClick={() => this.handleChangeTab(4)}
                >
                  <i className="fa fa-exchange" />
                  Transactions
                </label>
              </div>
            </div>
            <div className="right_">
              {tab === 1 ? (
                <div className="overview-block">
                  <div className="rows">
                    <p id="balance_amount">
                      <PriceComp price={balance} />
                    </p>
                    <p>Current Balance</p>
                    {paywait !== 0 ? (
                      <p>
                        Holding Balance <PriceComp price={paywait} />
                      </p>
                    ) : null}
                  </div>
                  <div className="rows">
                    <p>
                      <PriceComp price={earned} />
                    </p>
                    <p>Earned</p>
                    <p>This Month</p>
                  </div>
                  <div className="rows">
                    <p>
                      <PriceComp price={spent} />
                    </p>
                    <p>Spent</p>
                    <p>This Month</p>
                  </div>
                </div>
              ) : null}

              {tab === 2 ? (
                <div className="account-block">
                  <div className="rows">
                    <div className="heading">
                      <h1>Bank Account</h1>
                      <span onClick={this.handlePopup}>Add Account</span>
                    </div>
                    <div className="table">
                      <table>
                        <thead>
                          <tr>
                            <th>NAME</th>
                            <th>BANK</th>
                            <th>A/C NUMBER</th>
                            <th>IFSC</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bank_account &&
                            bank_account.map((bank, i) => (
                              <tr key={i} id={`bank_${bank.id}`}>
                                <td>{bank.bank_holder}</td>
                                <td>{bank.bank_type}</td>
                                <td>{bank.bank_num}</td>
                                <td>{bank.bank_ifsc}</td>
                                <td>
                                  <i
                                    className="fa fa-edit"
                                    onClick={() => this.handleBankEdit(bank)}
                                  />{" "}
                                  <i
                                    className="fa fa-trash"
                                    onClick={() =>
                                      this.handleBankDelete(bank.id)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : null}

              {tab === 3 ? (
                <form onSubmit={this.handleSubmitWithdraw}>
                  <div className="form-block">
                    <div className="rows">
                      <h1>Withdraw</h1>
                      <div className="form-group">
                        <label>Card number</label>
                        <select name="bank_detils">
                          {bank_account &&
                            bank_account.map((bank, i) => (
                              <option
                                key={i}
                                value={`${bank.id} - ${bank.bank_holder} - ${bank.bank_type} - ${bank.bank_num} - ${bank.bank_ifsc}`}
                              >
                                {`${bank.bank_type} - ${bank.bank_num}`}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Available Balance</label>
                        <input
                          type="hidden"
                          name="currency"
                          value={this.props.currency_id}
                          readOnly
                        />
                        <b id="balance_amount">
                          <PriceComp price={balance} />
                        </b>

                        <b id="min_amount" className="d-n">
                          <PriceComp price={1} />
                        </b>
                      </div>

                      {parseFloat(bal_amount) > parseFloat(min_amount) ? (
                        <div className="form-group">
                          <label>Withdrawal Amount</label>

                          <input
                            type="text"
                            name="amount"
                            value={withdraw_amount}
                            onChange={this.handleChangeAmount}
                            required
                          />
                          {withdraw_amount < parseFloat(min_amount) ? (
                            <span className="color-red">
                              Amount should enter greater than{" "}
                              {parseFloat(min_amount)}
                            </span>
                          ) : withdraw_amount > parseFloat(bal_amount) ? (
                            <span className="color-red">
                              Amount should enter less than balance
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        <div className="form-group">
                          Need to have{" "}
                          {parseFloat(bal_amount) - parseFloat(min_amount)}{" "}
                          amount to withdrawal
                        </div>
                      )}
                      {withdraw_amount >= parseFloat(min_amount) &&
                      withdraw_amount <= parseFloat(bal_amount) ? (
                        <div className="form-group">
                          <label>Password</label>
                          <input
                            type="password"
                            name="password"
                            autoComplete="new-password"
                            value={password}
                            onChange={e => this.handleChange(e, "password")}
                            onBlur={this.handleCheckPassword}
                            required
                          />

                          {error_pwd !== "" ? (
                            <span className="color-red">{error_pwd}</span>
                          ) : null}
                        </div>
                      ) : null}

                      {withdraw_amount >= parseFloat(min_amount) &&
                      withdraw_amount <= parseFloat(bal_amount) &&
                      isCheckedPassword ? (
                        <div align="right" className="save_btn">
                          <button>Make Withdrawal</button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </form>
              ) : null}

              {tab === 4 ? (
                <div className="account-block">
                  <div className="rows">
                    <h1>Heydesk Transactions</h1>
                    <div className="table">
                      <table>
                        <thead>
                          <tr>
                            <th>DATE</th>
                            <th>REASON</th>
                            <th>DR</th>
                            <th>CR</th>
                            <th>BALANCE</th>
                            {/* <th></th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {transactions &&
                            transactions
                              .sort((a, b) => b.id - a.id)
                              .map((account, i) => (
                                <tr key={i}>
                                  <td>
                                    {moment(account.created_date).format(
                                      "DD, MMM YYYY"
                                    )}
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        account.reason === "withdraw request"
                                          ? "color-red"
                                          : ""
                                      }
                                    >
                                      {account.reason}
                                    </span>
                                  </td>
                                  <td>
                                    {account.action_type === "payout" ? (
                                      <PriceComp price={account.price} />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {account.action_type === "payin" ? (
                                      <PriceComp price={account.price} />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    <PriceComp price={account.balance} />
                                  </td>
                                  {/* <td>
                                  <i className="fa fa-eye" />
                                </td> */}
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <LoadingComp customStyle={{ padding: "200px 0" }} />
    );
  }
}
